import { ColorX } from "../../../../STATIC";

let styles = {
  btn: {
    width: "50%"
  },
  btnBar: {
    width: "auto"
  },
  btnText: {
    fontFamily: "san-serif",
  }, 
  mainContainer: {
    backgroundColor: ColorX.CSS("cmBgBlue"),
    overflow: "hidden",
    padding: 0
  },
  modeBtn: {
    paddingLeft: 10,
    paddingRight: 10,
    padding: undefined,
    margin: 3
  }
};

export default styles;